import { FaGithub } from '@react-icons/all-files/fa/FaGithub';
import { FaMoon } from '@react-icons/all-files/fa/FaMoon';
import { FaPen } from '@react-icons/all-files/fa/FaPen';
import { FaRegUserCircle } from '@react-icons/all-files/fa/FaRegUserCircle';
import { FaSun } from '@react-icons/all-files/fa/FaSun';
import { FaGlobe } from "@react-icons/all-files/fa/FaGlobe";
import { FaCodeBranch } from '@react-icons/all-files/fa/FaCodeBranch';
import { FaLightbulb } from '@react-icons/all-files/fa/FaLightbulb';
import { GiSkills } from '@react-icons/all-files/gi/GiSkills';
import { GoPackage } from '@react-icons/all-files/go/GoPackage';
import { RiFileList3Line } from '@react-icons/all-files/ri/RiFileList3Line';
import { RiLogoutCircleLine } from '@react-icons/all-files/ri/RiLogoutCircleLine';
import { FiAlertTriangle } from '@react-icons/all-files/fi/FiAlertTriangle';
import { FiAlertCircle } from '@react-icons/all-files/fi/FiAlertCircle';
import { IoSearchOutline } from '@react-icons/all-files/io5/IoSearchOutline';
import { MdEmail } from '@react-icons/all-files/md/MdEmail';
import { RiMenu4Fill } from '@react-icons/all-files/ri/RiMenu4Fill';
import { FaTimes } from '@react-icons/all-files/fa/FaTimes';

export const Icons = {
  FaGithub,
  FaMoon,
  FaPen,
  FaRegUserCircle,
  FaSun,
  GiSkills,
  RiFileList3Line,
  RiLogoutCircleLine,
  FaGlobe,
  FaCodeBranch,
  GoPackage,
  FaLightbulb,
  FiAlertTriangle,
  FiAlertCircle,
  IoSearchOutline,
  MdEmail,
  RiMenu4Fill,
  FaTimes,
}